"use client";

import { useTranslations } from "next-intl";
import { Button } from "@/shared/ui/buttons/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/shared/ui/dropdown-menu";
import { LFG_ROLES, type LfgRole } from "../model/board-filters";
import { LfgRoleIcon } from "./board-card-parts";

const PRIMARY_BTN =
  "h-[34px] border-highlight-border bg-highlight-soft px-3.5 font-bold text-highlight hover:bg-highlight-soft/80 hover:text-highlight";

/** «Откликнуться»: одна позиция — сразу, несколько — спросить, на какую. Общая для доски и карточки в чате. */
export function ApplyButton({ lanes, disabled, onApply }: { lanes: LfgRole[]; disabled: boolean; onApply: (r: LfgRole) => void }) {
  const t = useTranslations("LfgBoard");
  if (lanes.length <= 1)
    return (
      <Button variant="outline" className={PRIMARY_BTN} disabled={disabled || lanes.length === 0} onClick={() => lanes[0] && onApply(lanes[0])}>
        {t("card.apply")}
      </Button>
    );
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className={PRIMARY_BTN} disabled={disabled}>{t("card.apply")}</Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {LFG_ROLES.filter((r) => lanes.includes(r)).map((r) => (
          <DropdownMenuItem key={r} onClick={() => onApply(r)} className="gap-2">
            <LfgRoleIcon role={r} />
            {t(`role.${r}`)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
